import { Link } from 'react-router-dom';

export default function CTA() {
  return (
    <section className="w-full bg-primary-500">
      <div className="w-full px-4 md:px-6 py-12 md:py-16">
        <div className="max-w-7xl mx-auto text-center">
          <h2 className="text-2xl md:text-3xl font-bold text-background-50 font-heading mb-3">
            海量电视剧，免费观看
          </h2>
          <p className="text-sm md:text-base text-background-50/80 mb-8 max-w-xl mx-auto">
            无需注册，无需付费，打开即看。高清画质不卡顿，追剧体验从此不同。
          </p>
          <Link
            to="/category/all"
            className="inline-flex items-center gap-2 px-8 py-3.5 bg-background-50 text-primary-500 rounded-full text-sm font-semibold hover:bg-background-100 transition-colors cursor-pointer whitespace-nowrap"
          >
            <i className="ri-play-circle-fill text-lg"></i>
            立即开始追剧
          </Link>
        </div>
      </div>
    </section>
  );
}